export const setPartnerData = (partnerData: Record<string, any>) => {
  localStorage.setItem('partnerData', JSON.stringify(partnerData));
};

export const getPartnerData = (): Record<string, any> => {
  const partnerData = localStorage.getItem('partnerData');
  if (!partnerData) return {};
  try {
    return JSON.parse(partnerData);
  } catch {
    return {};
  }
};
